import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {forkJoin} from 'rxjs';
import {NavService} from '../../_services/_nav.service';
import {CanalRolService} from '../../_services/canal-rol.service';
import {Modalidad} from '../../_models/modalidad';
import {ModalidadService} from '../../_services/modalidad.service';
import {SelectItem} from 'primeng/api';
import {ModalidadAutorizacion} from '../../_models/modalidad-autorizacion';
import {ModalidadAutorizacionService} from '../../_services/modalidad-autorizacion.service';
import {ListaService} from '../../_services/lista.service';
import {ListaItem} from '../../_models/lista-item';
import {ModalidadCalificacionService} from '../../_services/modalidad-calificacion.service';
import {ModalidadCalificacion} from '../../_models/modalidad-calificacion';

@Component({
  selector: 'app-canales-detalle',
  templateUrl: 'modalidades-detalle.component.html'
})

export class ModalidadesDetalleComponent implements OnInit {

  modalidad: Modalidad;
  lisAutorizaciones: SelectItem[] = [];
  lisModalidadesAutorizaciones: ModalidadAutorizacion [] = [];
  autorizaciones: any [] = [];
  carInformacionInicial = true;
  colAutorizacion: any[];
  tabSeleccionado = 'INFO';
  columnas: any[];
  lisModalidadesCalificaciones: ModalidadCalificacion [] = [];


  constructor(private modService: ModalidadService,
              private route: ActivatedRoute,
              private lisServicio: ListaService,
              private  modCalifiacionesServicio: ModalidadCalificacionService,
              private modAutServicio: ModalidadAutorizacionService,
              private canRolesServicio: CanalRolService,
              private nav: NavService,
              private location: Location) {
  }

  ngOnInit(): void {
    this.colAutorizacion = [
      {field: 'nombreDocumento', header: this.nav.buscarMensaje('MODALIDADES.LBL_NOMBREDOCUMENTO'), sort: true},
    ];

    // Definiendo columnas datatable
    this.columnas = [
      {field: 'categoria', header: this.nav.buscarMensaje('MODALIDADES.LBL_CATEGORIA'), sort: false},
      {field: 'diaMin', header: this.nav.buscarMensaje('MODALIDADES.LBL_DIAMINMORA'), sort: false},
      {field: 'diaMax', header: this.nav.buscarMensaje('MODALIDADES.LBL_DIAMAXMORA'), sort: false},
    ];
    this.route.params.subscribe((params: Params) => {
      forkJoin(
        this.modService.obtenerPorId(params['id']),
        this.lisServicio.getMasterDetails('ListasAutorizaciones')
      ).subscribe(([modalidad, autorizaciones ]) => {
        this.modalidad = modalidad;
        autorizaciones.map((s: ListaItem) => {
          this.lisAutorizaciones.push({label: s.nombre, value: s.idLista});
        });
        this.modCalifiacionesServicio.listadoModalidadesCalificacionesIdModalidad(this.modalidad.idModalidad).subscribe(
          res => {
            this.lisModalidadesCalificaciones = res;
          },
          error1 => {
            this.carInformacionInicial = true;
          }
        );
        this.modAutServicio.listadoModalidadesAutorizacionesHabilitadasIdModalidad(this.modalidad.idModalidad).subscribe(
          res => {
            this.lisModalidadesAutorizaciones = res;
            this.llenarAutorizaciones();
            this.carInformacionInicial = false;
          },
          error => {
            this.carInformacionInicial = true;
          });
      });
    });
  }

  regresar() {
    this.location.back();
  }

  //Se llena la lista que contiene las autorizaciones de la modalidad
  llenarAutorizaciones() {
    this.autorizaciones = [];
    for (let aut of this.lisAutorizaciones) {
      for (let modAut of this.lisModalidadesAutorizaciones) {
        if (aut.value === modAut.idAutorizacion) {
          this.autorizaciones.push(aut);
        }
      }
    }
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'FACT';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'CALI';
        break;
      }
      default: {
        break;
      }
    }
  }
}
